import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17255d00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment-field" }
const _hoisted_2 = { class: "comment-field__label" }
const _hoisted_3 = ["value", "placeholder", "disabled"]

import { scopedTranslation } from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { default: '' },
    disabled: { default: false }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: string, disabled: boolean }

const { sT } = scopedTranslation('comment')




const handleInput = (event: Event) => {
  const target = event.target as HTMLSelectElement
  if (target) {
    emit('update:modelValue', target.value)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(sT)('label')), 1),
    _createElementVNode("textarea", {
      class: "comment-field__textarea",
      value: props.modelValue,
      onInput: handleInput,
      placeholder: _unref(sT)('placeholder'),
      disabled: props.disabled
    }, null, 40, _hoisted_3)
  ]))
}
}

})